import { isDefined } from '@sgme/fp';
import {
  getIsWithAdditionalInformation,
  getReferentialStatus,
  isFeedbackInitialized,
} from 'state/missed-deal-feeedback/selectors';
import { getQuotePricerId, getWorkspaceTypeFromRouter } from 'state/selectors/common/commonForm';
import type { Thunk } from 'state/state.common';
import { canBeRetried } from 'utils/status';

import {
  missedDealFeedbackInit,
  missedDealFeedbackRequested,
  missedDealFeedbackSetWithAdditionalInformation,
  missedDealFeedbackSubmissionRequestConfirmed,
  missedDealFeedbackSubmissionRequested,
} from './actions';

export function missedDealFeedbackInitThunk(tabId: string, pricerId?: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();

    if (pricerId === undefined) {
      const workspace = getWorkspaceTypeFromRouter(state);
      pricerId = getQuotePricerId(state, workspace, tabId)!;
    }

    if (!isFeedbackInitialized(state, tabId) && isDefined(pricerId)) {
      dispatch(missedDealFeedbackInit(tabId, pricerId));
    }
  };
}

export function missedDealFeedbackSetWithAdditionalInformationThunk(
  tabId: string,
  withAdditionalInfo: boolean,
): Thunk<void> {
  return dispatch => {
    dispatch(missedDealFeedbackSetWithAdditionalInformation(tabId, withAdditionalInfo));
    dispatch(missedDealFeedbackRequestedThunk(tabId, withAdditionalInfo));
  };
}

export function missedDealFeedbackRequestedThunk(tabId: string, withAdditionalInfo?: boolean): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    withAdditionalInfo ??= getIsWithAdditionalInformation(state, tabId);
    const referentialStatus = getReferentialStatus(state, tabId);
    if (withAdditionalInfo === true && isDefined(referentialStatus) && canBeRetried(referentialStatus)) {
      dispatch(missedDealFeedbackRequested(tabId));
    }
  };
}

export function missedDealFeedbackSubmissionRequestConfirmedThunk(tabId: string): Thunk<void> {
  return (dispatch, _, { getNow, getSgmeConfiguration }) => {
    const timeoutInMilliseconds = getSgmeConfiguration().feedbackTimeoutMs;
    dispatch(missedDealFeedbackSubmissionRequestConfirmed(tabId, getNow().getTime(), timeoutInMilliseconds));
  };
}

export function missedDealFeedbackSubmissionRequestedThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    if (getIsWithAdditionalInformation(state, tabId)) {
      dispatch(missedDealFeedbackSubmissionRequested(tabId));
    } else {
      dispatch(missedDealFeedbackSubmissionRequestConfirmedThunk(tabId));
    }
  };
}
